import {
  FeatureFlag,
  useFeatureFlag,
  useFeatureFlagsStatus,
} from "../contexts/launchDarklyContext";

export type DarkModeAvailability = "pending" | "on" | "off";

/**
 * Whether the theme picker is offered, gated by the `dark-mode` LaunchDarkly
 * flag. "pending" until flags are authoritative, so the theme index.html
 * applied before paint is kept rather than flashed to light and back; "off"
 * if LaunchDarkly can't be reached or confirms the flag is off.
 */
export function useDarkModeAvailability(): DarkModeAvailability {
  const status = useFeatureFlagsStatus();
  const enabled = useFeatureFlag(FeatureFlag.darkMode);
  if (status === "pending") return "pending";
  return status === "ready" && enabled ? "on" : "off";
}
